import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWiiuComponent } from './simple-icons-wiiu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWiiuComponent ],
    exports:      [ SimpleIconsWiiuComponent ],
    bootstrap:    []
})
export class SimpleIconsWiiuModule {}
